import { Link, Outlet, useLocation, useMatch } from 'react-router-dom';
import './navbar.scss';

interface NavbarI{
  customClass?: string;
}

const Navbar: React.FC<NavbarI> = () => {

  const location = useLocation();

  const getLinkClass = (path: string) => {
    return location.pathname === path ? 'hover-underline-animation active' : 'hover-underline-animation';
  };

  const isContacts = useMatch('/contacts');

  return (
    <>
      <header className={'fixed w-full px-6 py-6 grid grid-cols-12 gap-6 text-light'}>
        <div className='col-span-4 hidden lg:block'>
          <h1>
            <Link to="/" className='back-to-home'>
              {isContacts && (
                <span className='arrow'>
                  ←
                </span>
              )}
              <span>
                Alessandro Serra<br/>
                Portfolio © 2026
              </span>
            </Link>
          </h1>
        </div>
        <div className='col-span-9 lg:hidden'>
          <h1>
            <Link to="/" className='back-to-home'>
              {isContacts && (
                <span className='arrow'>
                  ←
                </span>
              )}
              <span>
                Alessandro Serra<br/>
                Product Designer @ Accenture
              </span>
            </Link>
          </h1>
        </div>
        <div className='col-span-4 flex flex-col hidden lg:block'>
          <p>
            Product Designer<br/>at Accenture Song
          </p>
        </div>
        <div className='col-span-2 flex hidden lg:block'>
          <p>
            Based in Milan, Italy
          </p>
        </div>
        <div className='col-span-3 lg:col-span-2 text-right'>
          <Link to="/contacts" className={getLinkClass('/contacts')}>Contacts</Link>
        </div>
      </header>
      <Outlet />
    </>
  );
};

export default Navbar;